'use strict';

import angular from 'angular';

function GrpRoleResource($resource) {
  return $resource('/api/groups/:groupId/roles/:id/:controller', {
    id: '@id'
  }, {
    getForGroupUser: {
      method: 'GET',
      url: '/api/groups/:groupId/roles/all/users/:userId',
      isArray: true
    },
    set: {
      method: 'POST',
      params: {controller: 'users'}
    }
  });
}

GrpRoleResource.$inject = ['$resource'];

export default angular.module('georgeApp.grpRoleSvc', [])
  .factory('GrpRoleSvc', GrpRoleResource)
  .name;
